<script lang="ts">
  import { cn } from '$lib/utils';
  import { Dialog, DialogOverlay } from '@rgossiaux/svelte-headlessui';
  import { EditorJs } from 'query-strapi-v4';
  type Block = $$Generic<EditorJs.Image | undefined>;
  export let block = undefined as Block;

  const file = block.data.file;
  const defaultImage = file.formats?.medium ?? file.formats?.small ?? file.formats?.large ?? file;

  // Maybe only allow the lightbox for large images
  // const shouldExpandImage = Object.keys(file.formats).includes("large")

  let isOpen: boolean = false;
</script>

<div class="not-prose my-7">
  <button
    on:click={() => (isOpen = !isOpen)}
    class={cn(
      {
        'p-6 bg-zinc-100 dark:bg-zinc-900': block.data.withBackground
      },
      'w-full overflow-hidden cursor-zoom-in'
    )}
  >
    <img
      alt={file.alt}
      class={cn(
        {
          'mx-auto': block.data.withBackground
        },
        'not-prose max-w-full h-auto rounded-lg shadow-lg'
      )}
      width={defaultImage.width}
      height={defaultImage.height}
      src={defaultImage.url}
      loading="lazy"
    />
    {#if block.data.caption}
      <p class="italic text-sm mt-2 text-center">{block.data.caption}</p>
    {/if}
  </button>
</div>

<Dialog open={isOpen} on:close={() => (isOpen = false)} class="fixed inset-0 z-40 overflow-y-auto">
  <DialogOverlay class="fixed inset-0 bg-black/50" aria-hidden="true" />
  <div class="min-h-screen px-4 text-center">
    <div
      class="inline-block my-8 overflow-hidden text-left align-middle transition-all transform shadow-xl rounded-lg"
    >
      <img
        alt={file.alt}
        class="max-w-full mx-auto h-auto"
        width={file.width}
        height={file.height}
        src={file.url}
        loading="lazy"
      />
      <button
        on:click={() => (isOpen = false)}
        class="absolute top-2 right-2 text-white hover:text-black"
        title="close modal"
      >
        <span class="sr-only">Close</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-12 h-12"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </button>
    </div>
  </div>
</Dialog>
